import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export async function changePasswordByEmail(email: string) {
  return usersApi.post(
    apiRoutes.askPasswordRecovery,
    {},
    {
      params: {
        email,
      },
    },
  )
}
